import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Chip, Typography, useTheme } from '@mui/material';
import { IconChevronDown } from '@tabler/icons';
import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import FallbackTypography from 'src/components/shared/FallbackTypography';
import ManageReservationInfo from '../ManageReservationInfo';
import dayjs from 'dayjs';
import { getReservationStatusChipColor, ReservationType } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateFormat';
import { useSelector } from 'react-redux';

const TourOverViewEntityAccordion = ({ item, config, iconColor }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
    const theme = useTheme();

    const handleAccordionChange = () => {
        setIsExpanded(!isExpanded);
    };

    const isService = config.type === ReservationType.service;

    return (
        <Accordion sx={{ width: '100%' }} onChange={handleAccordionChange}>
            <AccordionSummary
                expandIcon={<IconChevronDown />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                    width: '100%',
                    background: isExpanded ? "#ECF2FF" : "inherit",
                }}
            >
                <Grid
                    container
                    sx={{
                        width: '100%',
                        display: "inline-flex",
                        justifyContent: "space-around",
                        borderRadius: "10px"
                    }}
                >
                    <Grid display="flex" alignItems="center" justifyContent="center">
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0,
                            px: 0.5,
                            py: 0.1,
                            borderRadius: 4,
                            bgcolor: config.bgColor,
                            border: `1px solid ${config.color}20`,
                            minWidth: 10,
                            boxShadow: theme.shadows[2]
                        }}>
                            <Avatar
                                sx={{
                                    bgcolor: 'transparent',
                                    color: config.color,
                                    width: 30,
                                    height: 30,
                                }}
                            >
                                {React.cloneElement(config.icon, {
                                    size: 25,
                                    color: iconColor || config.color
                                })}
                            </Avatar>
                        </Box>
                    </Grid>
                    <Grid>
                        <Typography variant="body2">ElementRef:</Typography>
                        <FallbackTypography fontWeight="bold" value={item?.ItemReference} />
                    </Grid>
                    <Grid>
                        <Typography variant="body2">CheckIn:</Typography>
                        <FallbackTypography
                            fontWeight="bold"
                            value={dayjs(item?.CheckIn, dateFormat).format(dateFormat)}
                        />
                    </Grid>
                    {!isService ?
                        (
                            <Grid>
                                <Typography variant="body2">CheckOut:</Typography>
                                <FallbackTypography
                                    fontWeight="bold"
                                    value={dayjs(item?.CheckOut, dateFormat).format(dateFormat)}
                                />
                            </Grid>
                        ) :
                        (

                            <Grid>
                                <Typography variant="body2" sx={{ visibility: "hidden", width: 80 }}>CheckOut:</Typography>
                            </Grid>
                        )
                    }
                    <Grid sx={{ width: 150 }}>
                        <Typography variant="body2">
                            {config.displayName}:
                        </Typography>
                        <FallbackTypography
                            fontWeight="bold"
                            value={item[config.nameKey]}
                        />
                    </Grid>
                    <Grid sx={{ width: 120 }}>
                        <Typography variant="body2">Total {reservationOverview?.ClientCurrency}:</Typography>
                        <FallbackTypography
                            fontWeight="bold"
                            value={`${item?.ClientNetSell?.Total?.toFixed(2) || '0.00'}`}
                        />
                    </Grid>
                    <Grid display="flex" alignItems="center" justifyContent="center">
                        <Chip
                            label={item?.Status}
                            size="small"
                            color={getReservationStatusChipColor(item?.Status)}
                            sx={{ fontSize: "0.75rem", fontWeight: "bold" }}
                        />
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <ManageReservationInfo item={item} />
            </AccordionDetails>
        </Accordion>
    );
};

export default TourOverViewEntityAccordion;